import { Component, OnInit } from '@angular/core';
import Chart from 'chart.js';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  public data = {
    "tripInfo": {
      "totalTrip": 70,
      "completed": 45,
      "yetToStart": 20,
      "pickUp": 30,
      "drop": 40
    },
    "vehInfo": {
      "totalVehicle": 90,
      "atHalt": 45,
      "inTransit": 30,
      "breakdown": 15
    },
    "alertInfo": {
      "sos": 0,
      "complaint": 10,
      "breakDown": 1
    },
    "attendance": {
      "yetToTravel": {
        "male": 100,
        "female": 150
      },
      "present": {
        "male": 120,
        "female": 100
      },
      "noShow": {
        "male": 60,
        "female": 50
      }
    },
    "empArrival": {
      "onTime": 30,
      "late": 20
    },
    "driverCommute": {
      "09:00": {
        "onTime": 30,
        "late": 70
      },
      "10:00": {
        "onTime": 90,
        "late": 10
      },
      "11:00": {
        "onTime": 98,
        "late": 2
      }
    },
    "shiftWiseAtten": {
      "09:00": {
        "male": 30,
        "female": 100
      },
      "10:00": {
        "male": 30,
        "female": 100
      },
      "11:00": {
        "male": 30,
        "female": 100
      }
    }
  }
  shifts:string[]=[];//get the shifts as an array
  shiftAttendance:any=[];//get shift object
  constructor() {}
  public employeeInfo = ['Jan', 'Feb', 'Mar', 'April', 'May'];
  public employeetData = [
    { data: [65, 59, 80, 81, 56], label: 'Total Employees' }
  ];
  ngOnInit(): void {
    this.shifts=Object.keys(this.data.shiftWiseAtten);
    this.shiftAttendance=this.data.shiftWiseAtten;
    // Chart.register(...registerables);
    console.log("checkkk>>>>")
    // this.renderChart();
  }
  renderChart(): void {console.log("c2222222222222heckkk>>>>")
    const chartConfig = {
      type: 'bar',
      data: {
        labels: this.shifts,
        datasets: [
          {
            label: 'Male',
            data: Object.keys(this.shiftAttendance).map(
              (shift) => this.shiftAttendance[shift].male
            ),
            backgroundColor: '#7F5CB1',
          },
          {
            label: 'Female',
            data: Object.keys(this.shiftAttendance).map(
              (shift) => this.shiftAttendance[shift].female
            ),
            backgroundColor: '#C9BBBB',
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: '# Employees',
              },
              gridLines: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Days of the Week',
              },
            },
          ],
        },
        legend: {
          display: true,
          position: 'bottom', // TypeScript may complain about this
          labels: {
            boxWidth: 15,
          },
        },
      },
    };

    const ctx = document.getElementById('weeklyAttendance') as HTMLCanvasElement;
    ctx.height = 180;
    new Chart(ctx, chartConfig as any); // Type assertion added here
  }
}
